import fetchLocation from "utils/fetch-locations"
import fetchSocialMedia from "utils/fetch-social-media"
import Layout from "../components/Layout"
import PageHero from "../components/PageHero"
import ReferencesList from "../components/ReferencesList"
import DynamicContent from "../components/content/DynamicContent"
import { createApolloClient } from "../utils/apollo"
import { buildListQuery } from "../utils/blueprints/references"
import fetchCompany from "../utils/fetch-company"
import fetchNav from "../utils/fetch-nav"
import fetchPage from "../utils/fetch-page"
import { replaceVariables } from "../utils/replaceVariables"

function Referenzen({
  caseStudies,
  portfolioData,
  navs,
  company,
  content,
  locations,
  socialMediaLinks,
}) {
  return (
    <Layout
      navs={navs}
      company={company}
      content={content}
      locations={locations}
      socialMediaLinks={socialMediaLinks}
    >
      <PageHero data={content} style={{ marginBottom: 0 }} />
      <ReferencesList
        references={caseStudies}
        portfolioData={portfolioData}
        content={content}
      />
      <DynamicContent content={content} />
    </Layout>
  )
}

// Data for current page
// export const getServerSideProps = async (context) => {
export const getStaticProps = async (context) => {
  const { previewData } = context
  const apollo = createApolloClient(previewData?.token ?? null)

  const [referencesData, navs, company, locations, socialMediaLinks, content] =
    await Promise.all([
      apollo.query({
        query: buildListQuery(),
      }),
      fetchNav(apollo, previewData?.unit),
      fetchCompany(apollo, previewData?.unit),
      fetchLocation(apollo, previewData?.unit),
      fetchSocialMedia(apollo, previewData?.unit),
      fetchPage({ apollo, slug: "referenzen", isPreview: previewData?.unit }),
    ])

  if (content?.errors?.length) {
    throw new Error(content.errors[0]?.message)
  }

  if (referencesData.errors?.length) {
    throw new Error(referencesData.errors[0]?.message)
  }

  const references = (referencesData.data.entries.data || []).filter((e) => !!e)

  if (!references.length || !content) {
    return {
      notFound: true,
    }
  }

  const caseStudies = references
  const portfolioData = references
    .map((reference) =>
      reference.portfolio_images.map((image) => ({
        reference,
        image,
      }))
    )
    .flat()

  return {
    props: {
      caseStudies,
      portfolioData,
      navs,
      company,
      locations,
      socialMediaLinks,
      content: await replaceVariables(content),
    },
    // revalidate: 30,
  }
}

export default Referenzen
